import {Component, OnInit} from '@angular/core';
import {MatDialog, MatDialogModule} from "@angular/material/dialog";
import {PagamentoFaturaService} from "../payment-invoice/payment-invoice.service";
import {lastValueFrom} from "rxjs";
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { SafeHtmlPipe } from '../safe-html.pipe';

@Component({
  selector: 'app-termos-uso-recorrencia',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, SafeHtmlPipe],
  templateUrl: './termos-uso-recorrencia.component.html',
  styleUrls: ['./termos-uso-recorrencia.component.css']
})
export class TermosUsoRecorrenciaComponent implements OnInit {
  public constructor(
    private matDialog: MatDialog,
    private faturaService: PagamentoFaturaService,
  ) {

  }
  public termos: string = "";
  async ngOnInit(): Promise<void> {
    try {
      this.faturaService.showSpinner();
      this.termos = await lastValueFrom(this.faturaService.getTermosUsoRecorrencia());
    } catch (e) {
      console.error(e);
    } finally {
      this.faturaService.hideSpinner();
    }
  }
}
